import { render, staticRenderFns } from "./query-error.vue?vue&type=template&id=4b31b8f3"
import script from "./query-error.vue?vue&type=script&lang=js"
export * from "./query-error.vue?vue&type=script&lang=js"
import style0 from "./query-error.vue?vue&type=style&index=0&id=4b31b8f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports